import { Link, Location, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { logout } from '../../features/auth/AuthSlice';
import { useCanAccess } from '../auth/useCanAccess';
import { isDiagnosticsFeatureEnabled } from '../diagnostics/featureSwitch';
import { DIAGNOSTICS_ROUTE } from '../diagnostics/routes';

const NavBar = () => {
  const dispatch = useDispatch();
  const canRecomputeInsight = useCanAccess('admin');
  const location: Location = useLocation();
  const paths: Array<string> = location.pathname.split('/').slice(1);

  const onLogoutClicked = () => dispatch(logout());

  return (
    <div className="d-flex mb-4 align-items-center">
      <div className="mr-auto">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb mb-0">
            {paths.map((path, index: number) => {
              const to = `/${paths.slice(0, index + 1).join('/')}`;
              return (
                <li key={index} className={`breadcrumb-item ${index === paths.length - 1 ? 'active' : ''}`}>
                  <Link to={to}>{path}</Link>
                </li>
              );
            })}
          </ol>
        </nav>
      </div>
      <div className="d-flex align-items-center">
        <Link to="/users" className="btn btn-primary m-2">
          Users
        </Link>
        <Link to="/login-users" className="btn btn-primary m-2">
          Login users
        </Link>{' '}
        <Link to="/api-page" className="btn btn-primary m-2">
          Api
        </Link>
        <Link to="/coupons" className="btn btn-primary m-2">
          Coupons
        </Link>
        <Link to="/event-types" className="btn btn-primary m-2">
          Event types
        </Link>
        <Link to="/feature-flags" className="btn btn-primary m-2">
          Feature flags
        </Link>
        {canRecomputeInsight && (
          <Link to="/insight-recompute" className="btn btn-primary m-2">
            Insight recompute
          </Link>
        )}
        {isDiagnosticsFeatureEnabled() && (
          <Link to={DIAGNOSTICS_ROUTE} className="btn btn-primary m-2">
            Diagnostics
          </Link>
        )}
        <div className="ml-5">
          <button className="btn btn-outline-danger btn-sm" onClick={onLogoutClicked}>
            logout
          </button>
        </div>
      </div>
    </div>
  );
};
export default NavBar;
